"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REPORT_PAGE_EVENT = exports.INIT_ANALYTICS = void 0;
var ANALYTICS_FEATURE = "analytics";
exports.INIT_ANALYTICS = "".concat(ANALYTICS_FEATURE, "/INIT_ANALYTICS");
exports.REPORT_PAGE_EVENT = "".concat(ANALYTICS_FEATURE, "/THROW_PAGE_EVENT");
